import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
let InstructorsTableInstructorKidSchoolCell = class InstructorsTableInstructorKidSchoolCell extends Vue {
};
InstructorsTableInstructorKidSchoolCell = __decorate([
    Component
], InstructorsTableInstructorKidSchoolCell);
export default InstructorsTableInstructorKidSchoolCell;
